import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { CommandPaletteSearchResult } from "components/CommandPalette/types";

import { SEARCH_MODULES_FOR_NAVIGATION, SearchModulesForNavigationItem } from "./gql";

type UseModuleSearchForNavigationProps = {
  query: string;
};

const useModuleSearchForNavigation = ({
  query,
}: UseModuleSearchForNavigationProps): CommandPaletteSearchResult<SearchModulesForNavigationItem> => {
  const { data, previousData, loading } = useQuery(SEARCH_MODULES_FOR_NAVIGATION, {
    variables: {
      input: {
        after: null,
        first: 10,
        fullTextSearch: query,
        predicates: [],
        orderBy: null,
        requestedPage: null,
      },
      returnModuleSharing: null,
    },
  });

  const modules = useMemo(() => {
    return (
      data?.searchModules?.edges.map((edge) => edge.node) ||
      previousData?.searchModules?.edges.map((edge) => edge.node) ||
      []
    );
  }, [data, previousData]);

  return {
    items: modules,
    loading,
    hasMore: !!data?.searchModules?.pageInfo.hasNextPage,
    isEmpty: modules.length === 0,
  };
};

export default useModuleSearchForNavigation;
